import { Link as RouterLink } from 'react-router-dom'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import { RiArrowLeftLine, RiArrowRightSLine } from 'react-icons/ri'
import {
  SENSEMAKER_OVERVIEW_BREADCRUMB_BACK_GAP_PX,
  SENSEMAKER_OVERVIEW_BREADCRUMB_CHEVRON_SIZE_PX,
  SENSEMAKER_OVERVIEW_BREADCRUMB_CURRENT_COLOR,
  SENSEMAKER_OVERVIEW_BREADCRUMB_FONT_SIZE_PX,
  SENSEMAKER_OVERVIEW_BREADCRUMB_GAP_PX,
  SENSEMAKER_OVERVIEW_BREADCRUMB_LETTER_SPACING_PX,
  SENSEMAKER_OVERVIEW_BREADCRUMB_LINE_HEIGHT_PX,
  SENSEMAKER_OVERVIEW_BREADCRUMB_LINK_COLOR,
  SENSEMAKER_OVERVIEW_BREADCRUMB_PADDING_Y_PX,
} from '../../lib/sensemaker-overview-layout'

interface Props {
  tenantName: string
}

const breadcrumbTextSx = {
  fontFamily: 'Inter, sans-serif',
  fontSize: `${SENSEMAKER_OVERVIEW_BREADCRUMB_FONT_SIZE_PX}px`,
  lineHeight: `${SENSEMAKER_OVERVIEW_BREADCRUMB_LINE_HEIGHT_PX}px`,
  letterSpacing: `${SENSEMAKER_OVERVIEW_BREADCRUMB_LETTER_SPACING_PX}px`,
}

export function SensemakerOverviewBreadcrumb({ tenantName }: Readonly<Props>) {
  return (
    <Box
      data-testid="sensemaker-overview-breadcrumb"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: `${SENSEMAKER_OVERVIEW_BREADCRUMB_BACK_GAP_PX}px`,
      }}
    >
      <IconButton
        component={RouterLink}
        to="/tenants"
        aria-label="Back to Sensemaker List"
        data-testid="sensemaker-overview-back"
        sx={{
          color: SENSEMAKER_OVERVIEW_BREADCRUMB_LINK_COLOR,
          p: '4px',
          ml: '-4px',
        }}
      >
        <RiArrowLeftLine size={20} />
      </IconButton>
      <Box
        component="nav"
        aria-label="Breadcrumb"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: `${SENSEMAKER_OVERVIEW_BREADCRUMB_GAP_PX}px`,
          py: `${SENSEMAKER_OVERVIEW_BREADCRUMB_PADDING_Y_PX}px`,
        }}
      >
        <Link
          component={RouterLink}
          to="/tenants"
          underline="none"
          sx={{
            ...breadcrumbTextSx,
            fontWeight: 400,
            color: SENSEMAKER_OVERVIEW_BREADCRUMB_LINK_COLOR,
            '&:hover': { color: SENSEMAKER_OVERVIEW_BREADCRUMB_CURRENT_COLOR },
          }}
        >
          Sensemaker List
        </Link>
        <Box
          component="span"
          sx={{
            color: SENSEMAKER_OVERVIEW_BREADCRUMB_LINK_COLOR,
            display: 'flex',
            alignItems: 'center',
          }}
          aria-hidden
        >
          <RiArrowRightSLine size={SENSEMAKER_OVERVIEW_BREADCRUMB_CHEVRON_SIZE_PX} />
        </Box>
        <Typography
          component="span"
          sx={{
            ...breadcrumbTextSx,
            fontWeight: 500,
            color: SENSEMAKER_OVERVIEW_BREADCRUMB_CURRENT_COLOR,
          }}
        >
          {tenantName}
        </Typography>
      </Box>
    </Box>
  )
}
